import React, { useEffect, useState } from "react";

import { Row, Col, Card, CardBody, Form, Label, CardImg,Button } from "reactstrap";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "../PublicPromoCode/datatables.scss";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import _ from "lodash";
import Select from "react-select";
import Dropzone from "react-dropzone";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
// import actions
import { connect } from "react-redux";
import {
  setAllCategories,
  setAllMerchants,
} from "../../store/cms-actions/postActions";
import { CircularProgress } from "@material-ui/core";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";


const EditMarketPlaceBanner = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];

  const [token, setToken] = useState();
  const [selectedFiles, setselectedFiles] = useState([]);
  const [selectedSection, setselectedSection] = useState();
  const [estore, setEstore] = useState(false);
  const [makanMaster, setMakanMaster] = useState(false);
  const [grabFood, setGrabFood] = useState(false)
  const [selectedStatus, setselectedStatus] = useState(statusOptions[0].value);
  const [success_msg, setsuccess_msg] = useState(false);
  const [errorMessage, SetErrorMessage] = useState("");
  const [errorMsgAlert, setErrorMsgAlert] = useState(false);
  const [propsData, setPropsData] = useState();
  const [imageUrl, setImageUrl] = useState();
  const [loader,setLoader]=useState(false)


  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    if (props?.location?.state?.estore) {
      setEstore(true);
      setselectedSection({ value: "estore", path: "estore" });
    } else if (props?.location?.state?.makan_master) {
      setMakanMaster(true);
      setselectedSection({ value: "makan_master", path: "makan-master" });
    }else if(props.location.state?.grab_food_banner){
      setselectedSection({ value: "grab_food_banner",path:"grab-food"})
      setGrabFood(true)
    } 

    if (props?.location?.state?.edit) {
      setPropsData(props?.location?.state);
      // var position = props.location.state?.item?.sort_order;
      var imageUrl = props.location.state?.item?.userfile;
      var status = props.location.state?.item?.item_status;
      // var publishDate = props.location.state?.item?.publish_date;
      // if (
      //   props?.location?.state?.item?.unpublish_date == null ||
      //   props?.location?.state?.item?.unpublish_date == undefined
      // ) {
      //   setNeverEnding(!neverEnding);
      // }
      setselectedStatus(status)
      // setPublishDate(moment(publishDate).format("YYYY-MM-DDTHH:mm"));
      // setselectedPosition(position);
      setImageUrl(imageUrl);
    }
  }, []);

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    let path = files[0].path;
    path = path.split(".");
    path = path[1];
    if (path == "jpg"  || path == "JPG") {
      setselectedFiles(files);
      setImageUrl('')
    } else {
      SetErrorMessage("Please select a .jpg file");
      setErrorMsgAlert(true);
    }
  }


  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          setsuccess_msg(false);
          setLoader(false)
          props?.history.push(`/market-place/${selectedSection?.path}`);
        }}
        onConfirm={() => {
          setsuccess_msg(false);
          setLoader(false)
          props?.history.push(`/market-place/${selectedSection?.path}`);
        }}
        onCancel={() => {
          setsuccess_msg(false);
        }}
      >
        { "Banner Updated Succesfully"}
      </SweetAlert>
    );
  };
  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false);
          setLoader(false)
          // props?.history.push(`/single-banners/${selectedSection?.path}`)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };
  const validateFileSize = (file) => {
    console.log("here is the validate file----->", file);
    var reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(file[0]);
    reader.onloadend = function (e) {
      //Initiate the JavaScript Image object.
      var image = new Image();

      //Set the Base64 string return from FileReader as source.
      image.src = e.target.result;
      //Validate the File Height and Width.
      image.onload = function () {
        var height = this.height;
        var width = this.width;

        if (width !== 585 || height !== 333) {
          SetErrorMessage("Height and Width must be 585X333px");
          setErrorMsgAlert(true);
          return false;
        }
        handleAcceptedFiles(file);
        return true;
      };
    };
  };

  async function handleSubmit() {
    // const version = document.getElementById("version_input").value;
    const status = selectedStatus ? selectedStatus : "";
    if(!imageUrl)
    { if (selectedFiles.length < 1) {
      setErrorMsgAlert(true)
      SetErrorMessage("Please select image")
      return
    } }

    setLoader(true)
    let _deeplinkObj = {
      section: "",
      params: {
        
      },
      website_params: {},
    };

    if(selectedSection.value=="estore"){
      _deeplinkObj.section ="StoreMainScreen"
      _deeplinkObj.params.CampaignMedium ="MarketPlaceBanner"
      _deeplinkObj.params.link ="estore"
    }else if(selectedSection.value=="makan_master"){
      _deeplinkObj.section ="MakanMasterHome"
      _deeplinkObj.params.CampaignMedium ="MarketPlaceBanner"
      _deeplinkObj.params.link ="Makan Master"
    }else if(selectedSection.value=="grab_food_banner"){
      _deeplinkObj.section ="GrabFoodBanner"
      _deeplinkObj.params.CampaignMedium ="GrabFoodBanner"
      _deeplinkObj.params.link ="Grab Food Banner"
    }

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("_method","PUT")
    formdata.append("id",propsData?.item?.id)
    formdata.append("sort_order",1);
    if (!imageUrl) {
      formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);
    }
    formdata.append("page", selectedSection?.value);
    formdata.append("item_type", "MarketPlaceBanner");
    // formdata.append("publish_date", publishAt);
    // formdata.append("unpublish_date", neverEnding ? null : unpublishAt);
    formdata.append("item_status", status);
    formdata.append("item_version", 18);
    formdata.append("navigate_to", JSON.stringify(_deeplinkObj));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      // processData: false,
      // mimeType: "multipart/form-data",
      // async: true,
      // crossDomain: true,
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/marketplacebanners/update`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          if (result?.message.includes("update")) {
            setsuccess_msg(true);
          }
        } else {
          SetErrorMessage("Unable to Add Single Banner");
          setErrorMsgAlert(true);
        }
      })
      .catch((error) => console.log("error", error));
  }
  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Single Banners"
            breadcrumbItem={props.location.state.estore?"Edit eStore Banner":"Edit Makan Master Banner"}
          />
          <Row>
            <Col className="col-12">
              <Card><CardBody>
              {/* <Card>
                <CardBody>
                  <Row>
                    <Col lg={10} md={10} sm={10}>
                      <div className="mt-5 mt-lg-4">
                        <Form className="" method="post" id="tooltipForm">
                          <div>
                            <Row>
                              <Col lg={4} md={6} sm={6}>
                                <div className="mb-3">
                                  <Label>Position</Label>
                                  <div className="col-md-12">
                                    <input
                                      // onKeyPress={(event) => {
                                      //   if (!/[0-9]/.test(event.key)) {
                                      //     event.preventDefault();
                                      //   }
                                      // }}
                                      className="form-control"
                                      type="number"
                                      defaultValue={selectedPosition}
                                      id="position_input"
                                      onChange={(e) => {
                                        setselectedPosition(e.target.value);
                                      }}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Form>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card> */}
              <Card>
                <CardBody>
                  <Form>
                    {imageUrl && (
                      <Row>
                        <Col md={3}>
                          <CardImg
                            className="img-fluid"
                            src={imageUrl}
                            style={{
                              marginBottom: 15,
                              width: "400px",
                            }}
                            alt=""
                          />
                        </Col>
                        <Col
                          md={2}
                        >
                          <div
                            style={{ cursor: "pointer" }}
                            className="px-3 text-danger"
                            onClick={() => {
                              setImageUrl("");
                            }}
                          >
                            <FaRegTrashAlt />
                            Move To Trash
                          </div>
                        </Col>
                      </Row>
                    )}
                    <Dropzone
                      onDrop={(acceptedFiles) => {
                        validateFileSize(acceptedFiles);
                      }}
                      // disabled={pocuno}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div
                          className="dropzone"
                        >
                          <div
                            className="dz-message needsclick"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            <div className="mb-3">
                              <FaCloudUploadAlt className="display-4 text-muted"/>
                            </div>
                            <h4>Drop files here or click to upload.</h4>
   
                              <p style={{ fontSize: 12, color: "red" }}>
                                Image should be 585X333px in jpg
                              </p>

                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <div className="dropzone-previews mt-3" id="file-previews">
                      {selectedFiles.map((f, i) => {
                        console.log("here is the selected file----->", f);
                        return (
                          <Card
                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                            key={i + "-file"}
                          >
                            <div className="p-2">
                              <Row className="align-items-center">
                                <Col className="col-auto">
                                  <img
                                    data-dz-thumbnail=""
                                    height="80"
                                    className="avatar-sm rounded bg-light"
                                    alt={f.name}
                                    src={f.preview}
                                  />
                                </Col>
                                <Col>
                                  <Link
                                    to="#"
                                    className="text-muted font-weight-bold"
                                  >
                                    {f.name}
                                  </Link>
                                  <p className="mb-0">
                                    <strong>{f.formattedSize}</strong>
                                  </p>
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        );
                      })}
                    </div>
                  </Form>
                  {/* <div className="text-center mt-4">
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light"
                    >
                      Send Files
                    </button>
                  </div> */}
                </CardBody>
              </Card>
              {/* <Card>
                <CardBody>
                  <Row>
                    <Col lg={4} md={6} sm={6}>
                      <div className="mb-3">
                        <Label>Publish At</Label>
                        <div className="col-md-12">
                          <input
                            // value={moment(propsData?.item?.publish_date).format("YYYY-MM-DDTHH:mm")}
                            className="form-control"
                            type="datetime-local"
                            id="publishAt_input"
                            defaultValue={
                              propsData?.item?.publish_date
                                ? moment(propsData?.item?.publish_date).format(
                                    "YYYY-MM-DDTHH:mm"
                                  )
                                : ""
                            }
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg={1}></Col>
                    <Col lg={4} md={6} sm={6}>
                      <div className="mb-3">
                        <Label>Unpublish At</Label>
                        <div className="col-md-12">
                          <input
                            disabled={neverEnding}
                            className="form-control"
                            type="datetime-local"
                            id="unpublishAt_input"
                            defaultValue={
                              propsData?.item?.unpublish_date
                                ? moment(
                                    propsData?.item?.unpublish_date
                                  ).format("YYYY-MM-DDTHH:mm")
                                : ""
                            }
                            min={""}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col style={{ paddingTop: 35 }}>
                      <div className="form-check form-switch">
                        <input
                          type="checkbox"
                          className="form-check-input checkbox"
                          id="checkbox_1"
                          checked={neverEnding}
                          onChange={() => {
                            setNeverEnding(!neverEnding);
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="checkbox_1"
                        >
                          Never-ending
                        </label>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card> */}
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={4} md={6} sm={6}>
                      <div className="mb-3">
                        <Label>Status</Label>
                        <Select
                          options={statusOptions}
                          // isSearchable={true}
                          // value={selectedStatus}
                          onChange={(e) => {
                            setselectedStatus(e.value);
                          }}
                          placeholder={
                            selectedStatus
                              ? selectedStatus == "Y"
                                ? "Enable"
                                : "Disable"
                              : "Choose..."
                          }
                          defaultValue={selectedStatus}
                          required
                        />
                      </div>
                    </Col>
                    {/* <Col lg={1}></Col>
                    <Col lg={4} md={6} sm={6}>
                      <div className="mb-3">
                        <Label>Version</Label>
                        <div className="col-md-12">
                          <input
                            className="form-control"
                            type="text"
                            id="version_input"
                            defaultValue={propsData?.item?.item_version}
                          />
                          <small className="text-muted user-select-none">
                            For mobile app only
                          </small>
                        </div>
                      </div>
                    </Col> */}
                  </Row>
                </CardBody>
              </Card>
              {success_msg ? renderSuccessAlert() : null}
              {errorMsgAlert ? renderFailureAlert() : null}
              <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push(`/market-place/${selectedSection?.path}`)
                        }}
                        color="danger"
                        type="submit"
                      >
                        Cancel
                      </Button>
                      <button
                      disabled={loader}
                      style={{color:"#ffffff", width:"80px",marginLeft: "10px"}}
                      className={ "btn btn-success"}
                        onClick={() => {
                          handleSubmit()
                        }}
                        color="success"
                        type="submit"
                      >
                        {loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Save"}
                      </button>
              </div>
              </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { allCategories, allMerchants } = state.rootReducers1;
  return { allCategories, allMerchants };
};

const actions = {
  setAllCategories,
  setAllMerchants,
};

export default connect(mapStateToProps, actions)(EditMarketPlaceBanner);
